import { AlertOctagon, CheckCircle2, Clock, ShieldAlert, Undo, XCircle } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { SaleStatus } from '@shared/contracts/enums'
import type { StatusTone } from '@shared/design-system/ui'

type SaleStatusPresentation = {
  tone: StatusTone
  label: string
  icon: LucideIcon
}

const presentationByStatus: Record<SaleStatus, SaleStatusPresentation> = {
  PENDING: { tone: 'awaiting', label: 'Pendente', icon: Clock },
  PAID: { tone: 'success', label: 'Paga', icon: CheckCircle2 },
  FAILED: { tone: 'closed', label: 'Recusada', icon: XCircle },
  REFUND_REQUESTED: { tone: 'awaiting', label: 'Aguardando reembolso', icon: Undo },
  REFUNDED: { tone: 'informative', label: 'Estorno', icon: Undo },
  CHARGED_BACK: { tone: 'closed', label: 'Chargeback', icon: AlertOctagon },
}

const globalChargebackRefundPresentation: SaleStatusPresentation = {
  tone: 'closed',
  label: 'Reembolso de chargeback',
  icon: ShieldAlert,
}

type SaleStatusPresentationInput =
  | SaleStatus
  | { status: SaleStatus; handledByGlobalChargeback?: boolean }

export function getSaleStatusPresentation(
  input: SaleStatusPresentationInput,
): SaleStatusPresentation {
  const status = typeof input === 'string' ? input : input.status
  const handledByGlobalChargeback =
    typeof input === 'string' ? false : Boolean(input.handledByGlobalChargeback)

  if (status === 'REFUNDED' && handledByGlobalChargeback) {
    return globalChargebackRefundPresentation
  }

  return presentationByStatus[status]
}
